export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous Page"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next Page"])},
        "page": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page"])}
      },
      "de": {
        "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorherige Seite"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nächste Seite"])},
        "page": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seite"])}
      }
    }
  })
}
